<template>
    <v-container fluid v-if="activeProject">
        <v-card class="mb-3">
            <v-card-text>
                <div class="title">Bot {{activeProject.bot_name}} - Agent Detail</div>
                <v-layout align-center>
                    <span class="mr-3 d-none">
                        <v-autocomplete
                            v-model="agent"
                            :label="$filters.capitalize($t('agent'))"
                            :items="agentList"
                            clearable
                        ></v-autocomplete>
                    </span>
                    <span class="mr-3">
                        <v-autocomplete
                            v-model="channel"
                            :label="$filters.capitalize($t('channel'))"
                            :items="channelList"
                            clearable
                        ></v-autocomplete>
                    </span>
                    <span class="mr-3">
                        <DatePicker
                            v-model="fromDate"
                            :label="$filters.capitalize($t('from'))"
                            :max="toDate"
                        ></DatePicker>
                    </span>
                    <span>
                        <DatePicker
                            v-model="toDate"
                            :label="$filters.capitalize($t('to'))"
                            :min="fromDate"
                            :max="today"
                        ></DatePicker>
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="#878787" dark @click="loadDataTable" class="btn-update text-capitalize">
                        <v-icon class="mr-1">mdi-sync</v-icon>
                        {{$t('update')}}
                    </v-btn>
                    <v-btn depressed color="#42BE80" dark @click="getAgentReportDetailsExcel" class="text-capitalize">
                        <v-icon class="mr-1">mdi-file-excel</v-icon>
                        {{$t('exportReport')}}
                    </v-btn>
                </v-layout>
            </v-card-text>
        </v-card>
        <v-card>
            <SimpleDataTable
                :headers="headers"
                :items="dataTable"
                :pagination.sync="pagination"
            >
                <template v-slot:sender_name="props">
                    <v-layout align-center>
                        <img
                            :src="`/img/channel_icon/${props.item.channel}.png`"
                            :alt="props.item.channel"
                            class="mr-1"
                            style="width: 20px;height: 20px;"/>
                        <span>{{props.item.sender_name}}</span>
                    </v-layout>
                </template>
                <template v-slot:rate_level="props">
                    <v-layout align-center>
                        <span>{{props.item.rate_level}}</span>
                        <v-icon size="16" color="yellow" style="text-shadow: 0 0 3px #000">mdi-star</v-icon>
                    </v-layout>
                </template>
            </SimpleDataTable>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from 'vuex'
import DatePicker from '@/components/DatePicker'
import moment from 'moment'
import SimpleDataTable from '@/components/SimpleDataTable'
import AgentService from '@/services/agent.service'
import DataTableMixin from '@/mixins/DataTableMixin'

export default {
    name: 'AgentDetails',
    components: { DatePicker, SimpleDataTable },
    mixins: [DataTableMixin],
    data () {
        return {
            agent: '',
            channel: '',
            channelList: this.$const.channelList,
            fromDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD'),
            baseUrl: process.env.BASE_URL
        }
    },
    computed: {
        ...mapState({
            activeProject: state => state.user.activeProject,
            agentList: state => state.user.agentList
        }),
        filter () {
            return {
                agent: this.agent,
                channel: this.channel,
                fromDate: this.fromDate,
                toDate: this.toDate
            }
        },
        headers () {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('time'),
                    value: 'created',
                    $value: item => this.$filters.formatDateTime(item.created)
                },
                {
                    text: this.$t('agent'),
                    value: 'agent_email'
                },
                {
                    text: this.$t('session_id'),
                    value: 'session_id',
                    id: 'session_id'
                },
                {
                    text: this.$t('user'),
                    value: 'sender_name',
                    type: 'custom',
                    id: 'sender_name'
                },
                {
                    text: this.$t('rated'),
                    value: 'rate_level',
                    type: 'custom',
                    id: 'rate_level'
                },
                {
                    text: this.$t('comment'),
                    value: 'rate_message'
                }
            ])
        }
    },
    methods: {
        getDataTablePromise () {
            return AgentService.getAgentDetailsReport(this.agent, this.channel, this.fromDate, this.toDate, this.pagination)
        },
        getAgentReportDetailsExcel () {
            return AgentService.getAgentReportDetailsExcel(this.agent, this.channel, this.fromDate, this.toDate)
        }
    },
    watch: {
        activeProject () {
            this.loadDataTable()
        },
        filter () {
            this.loadDataTable()
            this.pagination.page = 1
        }
    }
}
</script>

<style scoped>

</style>
